export enum DASHBOARD_ACTION_TYPE {
  OVERVIEW = 'dashboard/overview',
  PROJECT_OVERVIEW = 'dashboard/projectOverview',
  EMPLOYEE = 'dashboard/employee',
  CLEAR_LIST = 'dashboard/employeeClear',
}
